import React from 'react';
import { withStyles } from '@material-ui/styles';
import { translate } from '../../../i18n/I18nProvider';
import clsx from 'clsx';

import styles from '../styles';

const InfoBox = ({ classes }) => {
  return (
    <div className={classes.infoBox}>
      <i className={clsx('fas fa-info-circle', classes.infoIcon)} />
      <div
        dangerouslySetInnerHTML={{
          __html: translate('MOVE_NUMBER_RANGE_INFO')
        }}
      />
    </div>
  );
};
export default withStyles(styles)(InfoBox);
